import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-h5" }, "Social Accounts Pending Client Action", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "q-pa-md" }, " No client action is required. ", -1)
const _hoisted_3 = { class: "q-pa-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_clients_loader = _resolveComponent("clients-loader")!
  const _component_sites_loader = _resolveComponent("sites-loader")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_view_request_btn = _resolveComponent("view-request-btn")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_clients_loader, {
      "customer-id": _ctx.customerId,
      filters: _ctx.clientFilters,
      fields: ['client.socialAccounts'],
      onLoaded: _ctx.onClientsLoaded
    }, null, 8, ["customer-id", "filters", "fields", "onLoaded"]),
    _createVNode(_component_sites_loader, {
      modelValue: _ctx.socialSites,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.socialSites) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_q_table, _mergeProps({
      columns: _ctx.columns,
      rows: _ctx.clients,
      pagination: _ctx.pagination,
      "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pagination) = $event))
    }, _ctx.$attrs, {
      onRequest: _cache[4] || (_cache[4] = ($event: any) => (_ctx.pagination = $event.pagination))
    }), {
      top: _withCtx(() => [
        _createVNode(_component_q_input, {
          modelValue: _ctx.keyword,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.keyword) = $event)),
          placeholder: "Name, email, file ref no.",
          "clear-icon": "fa fa-times",
          clearable: "",
          style: {"min-width":"320px"},
          filled: "",
          dense: "",
          autocomplete: "no",
          onClear: _cache[2] || (_cache[2] = ($event: any) => (_ctx.keyword = ''))
        }, {
          prepend: _withCtx(() => [
            _createVNode(_component_q_icon, { name: "fa fa-search" })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      "body-cell": _withCtx((props) => [
        (props.col.name === 'client')
          ? (_openBlock(), _createBlock(_component_q_td, {
              key: 0,
              props: props
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  to: {name: 'client_profile', params: {clientId: props.row.id}},
                  class: "link",
                  title: "View Profile"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$filters.clientNameFilter(props.row)), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 2
            }, 1032, ["props"]))
          : (props.col.socialSite)
            ? (_openBlock(), _createBlock(_component_q_td, {
                key: 1,
                props: props
              }, {
                default: _withCtx(() => [
                  (props.value && props.value.reconnectRequest)
                    ? (_openBlock(), _createBlock(_component_view_request_btn, {
                        key: 0,
                        request: props.value.reconnectRequest,
                        platform: props.col.socialSite.name
                      }, null, 8, ["request", "platform"]))
                    : (props.value && !props.value.reconnectRequest)
                      ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
                          key: 1,
                          icon: "fa fa-check-circle",
                          color: "positive",
                          rounded: "",
                          flat: ""
                        }, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_q_btn_dropdown, {
                          key: 2,
                          icon: "fa fa-times",
                          rounded: "",
                          flat: ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(props.col.socialSite.name) + " account was not added by the client. ", 1)
                          ]),
                          _: 2
                        }, 1024))
                ]),
                _: 2
              }, 1032, ["props"]))
            : (_openBlock(), _createBlock(_component_q_td, {
                key: 2,
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.value), 1)
                ]),
                _: 2
              }, 1032, ["props"]))
      ]),
      _: 1
    }, 16, ["columns", "rows", "pagination"])
  ]))
}